<template>
    <div class="toast-progress-container">
        <div 
            class="toast-progress-bar"
            :style="{
                '--duration': duration + 'ms',
                '--color': progressColor
            }"
        ></div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
    message: {
        type: Object,
        required: true
    },
    color: {
        type: String,
        default: '#2E79C6' // $brand-primary from _variables.scss
    }
});

const progressColor = computed(() => props.color);
const duration = computed(() => props.message.life || 3000);

onMounted(() => {
    console.log('Progress bar mounted with duration:', duration.value);
});
</script>

<style scoped>
.toast-progress-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    bottom: -12px;
    height: 4px;
    pointer-events: none;
    overflow: hidden;
}

.toast-progress-bar {
    width: 100%;
    height: 100%;
    background: var(--color);
    transform-origin: left center;
    animation: shrinkToLeft var(--duration) linear forwards;
}

@keyframes shrinkToLeft {
    from {
        transform: scaleX(1);
    }
    to {
        transform: scaleX(0);
    }
}
</style>